exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3dFVHdF5r__dKHNaDQHjiK{height:32px}html[dir] ._3dFVHdF5r__dKHNaDQHjiK{border-radius:2px}html[dir=ltr] ._3dFVHdF5r__dKHNaDQHjiK{margin:0 26px 0 8px}html[dir=rtl] ._3dFVHdF5r__dKHNaDQHjiK{margin:0 8px 0 26px}html[dir=ltr] .azG0PNt5WhTJ6a_V-vpCd{margin-left:38px}html[dir=rtl] .azG0PNt5WhTJ6a_V-vpCd{margin-right:38px}", ""]);
// Exports
exports.locals = {
	"saveButton": "_3dFVHdF5r__dKHNaDQHjiK",
	"saveButtonHidden": "azG0PNt5WhTJ6a_V-vpCd"
};